"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMakePayOut = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useMakePayOut = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        keysUpdate: [keys_1.BALANCE, keys_1.BONUSES_BY_TYPE, keys_1.WITHDRAWAL_BALANCE],
        path: keys_1.PAY_OUT_MAKE,
    }), data = _c.data, mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        makePayOut: mutate,
        isSubmitting: isSubmitting,
        error: error,
        data: data,
    }); }, [mutate, isSubmitting, error]);
};
exports.useMakePayOut = useMakePayOut;
